import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Badge, Icon } from "@/components/ui";
import { ImmersiveShell } from "@/components/immersive/ImmersiveShell";

export default function IntakeDone() {
  const nav = useNavigate();
  const { state } = useLocation();
  const res = state?.result || {};
  const plan = res.care_plan || {};
  return (
    <ImmersiveShell showFooter={false}>
      <section className="imm-wrap" data-testid="intake-done-screen">
        <div className="imm-legal">
          <div className="imm-contact-done" style={{ paddingTop: 12 }}>
            <Icon name="check-circle" size={48} color="var(--success)" />
            <h3>Intake received — you're all set</h3>
            <p>{res.service_start_note || "Care begins 24 hours after your care plan is finalized."}</p>
            {res.urgency_escalated ? <div style={{ margin: "10px 0" }}><Badge testID="urgency-badge" label="Urgent — an on-call specialist has been alerted" tone="warning" /></div> : null}

            {plan.summary ? (
              <div style={{ textAlign: "left", margin: "18px auto 0", maxWidth: 460 }}>
                <div className="tag" style={{ marginBottom: 6 }}>CARE PLAN DRAFT</div>
                <div style={{ marginBottom: 6 }}><Badge label="drafted by system — needs review" tone="warning" /></div>
                <p style={{ fontSize: 15 }}>{plan.summary}</p>
                {(plan.tasks || []).map((t, i) => (
                  <div key={i} className="center-icon-row" style={{ marginTop: 4 }}>
                    <Icon name="check-circle" size={14} color="var(--success)" /><span style={{ fontSize: 14 }}>{t}</span>
                  </div>
                ))}
              </div>
            ) : null}

            <div style={{ textAlign: "left", margin: "18px auto 0", maxWidth: 460 }}>
              <div className="tag" style={{ marginBottom: 6 }}>NEXT STEPS</div>
              <p style={{ fontSize: 15, margin: "4px 0" }}>1. A coordinator reviews and finalizes your plan.</p>
              <p style={{ fontSize: 15, margin: "4px 0" }}>2. Care begins 24 hours later — day one is a free, unbilled trial.</p>
              <p style={{ fontSize: 15, margin: "4px 0" }}>3. A same-day coordinator check-in call is scheduled for the trial day.</p>
            </div>

            <div style={{ maxWidth: 380, margin: "20px auto 0", width: "100%" }}>
              <Button testID="go-signin" label="Sign in to your client portal" onClick={() => nav("/login")} />
              <div style={{ height: 8 }} />
              <Button testID="go-home" variant="ghost" label="Back to home" onClick={() => nav("/")} />
            </div>
          </div>
        </div>
      </section>
    </ImmersiveShell>
  );
}
